module.exports = __webpack_public_path__ + "cachable/fonts/fa-solid-900.dbf1fc91f1beec2915123257ea4d58ef.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-pro/webfonts/fa-solid-900.woff2
// module id = 1190
// module chunks = 0